import { useDispatch, useSelector } from "react-redux";

import { ErrorBanner } from "../../components/banner";
import { Section } from "../../components/section";
import { ServicesForm } from "./ServicesForm";
import { createService } from "../../redux/services";
import { useNavigate } from "react-router-dom";

export const ServicesCreate = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { error } = useSelector((state) => state.services);

  // 1. ADD 'attachedFiles' as the second parameter
  const onFormSubmit = (values, attachedFiles) => {
    if (window.confirm(`Are you sure you want to add this service?`)) {
      // 2. Combine the text values and the files into a single payload
      const payload = {
        ...values,
        files: attachedFiles,
      };

      // 3. Dispatch the combined payload
      return dispatch(createService(payload))
        .unwrap()
        .then(() => {
          navigate("/services");
        })
        .catch((err) => {
          console.error("Failed to create service:", err);
        });
    }
  };

  return (
    <Section>
      {error && <ErrorBanner text={error} />}
      <ServicesForm onFormSubmit={onFormSubmit} />
    </Section>
  );
};
